'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconTopper = require('./IconTopper');

var _IconTopper2 = _interopRequireDefault(_IconTopper);

var _styles = require('../styles');

var Styles = _interopRequireWildcard(_styles);

var _responsiveMixin = require('../util/responsiveMixin');

var _responsiveMixin2 = _interopRequireDefault(_responsiveMixin);

var _ContactThumbnail = require('./ContactThumbnail');

var _ContactThumbnail2 = _interopRequireDefault(_ContactThumbnail);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentInterstitial = _react2.default.createClass({
	displayName: 'PaymentInterstitial',

	mixins: [_responsiveMixin2.default],

	propTypes: {
		handleTypeChange: _react.PropTypes.func.isRequired,
		flowType: _react.PropTypes.string.isRequired,
		thumbnailUrl: _react.PropTypes.string,
		paymentContentHTML: _react.PropTypes.string.isRequired,
		note: _react.PropTypes.string.isRequired,
		mainContent: _react.PropTypes.shape({
			headerText: _react.PropTypes.string.isRequired,
			friendsAndFamily: _react.PropTypes.shape({
				title: _react.PropTypes.string.isRequired,
				blurb: _react.PropTypes.string.isRequired
			}).isRequired,
			goodsAndServices: _react.PropTypes.shape({
				title: _react.PropTypes.string.isRequired,
				recommended: _react.PropTypes.string.isRequired,
				blurb: _react.PropTypes.string.isRequired
			}).isRequired,
			footerNote: _react.PropTypes.string,
			PPPNote: _react.PropTypes.string.isRequired
		}).isRequired
	},

	/**
  * Updates the state, and calls the provided handler function
  */
	handleTypeChange: function handleTypeChange(newType) {
		this.props.handleTypeChange(newType);
	},
	render: function render() {
		var _this = this;

		// non-Styles styles
		var styles = {
			interstitialWrapper: {
				textAlign: 'center',
				padding: this.state.responsiveMixin.isSmall ? '50px 15px' : '50px',
				marginTop: '-25px'
			},
			paymentContent: {
				marginTop: '20px',
				fontSize: '23px'
			},
			headerText: {
				margin: '10px 0',
				fontSize: '23px'
			},
			line: {
				width: '100%',
				height: '1px',
				backgroundColor: '#cbd2d6',
				margin: '20px 0'
			},
			inputWrapper: {
				textAlign: 'left',
				borderRadius: '5px',
				position: 'relative',
				margin: '30px 0'
			},
			inputDetailsWrapper: {
				overflow: 'auto',
				marginLeft: '65px'
			},
			icon: {
				width: '40px',
				height: '40px',
				position: 'absolute',
				paddingTop: '10px',
				boxSizing: 'border-box',
				marginTop: '5px',
				color: '#0070ba'
			},
			registerPadding: {
				paddingLeft: '4px'
			},
			clickableText: {
				cursor: 'pointer'
			},
			inputTitle: {
				fontFamily: '"HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, sans-serif',
				fontSize: '1.33em',
				fontWeight: 'normal',
				margin: 0,
				color: '#0070BA',
				paddingRight: '20px'
			},
			typeBlurb: {
				margin: '8px 0 0',
				fontSize: '13px',
				color: '#2c2e2f',
				fontFamily: 'Helvetica, Arial, sans-serif'
			},
			arrowIcon: {
				position: 'absolute',
				marginTop: '15px',
				top: 0,
				right: 0,
				color: '#0070BA'
			},
			recommendedWrapper: {
				margin: '10px 0'
			},
			recommendedBlurb: {
				marginLeft: '5px',
				fontSize: '13px',
				display: 'inline',
				lineHeight: '1.4'
			},
			checkmark: {
				color: '#018065',
				marginLeft: '-3px'
			},
			PPPLink: {
				color: '#0070ba',
				textDecoration: 'none'
			},
			saveBlurb: {
				fontFamily: 'Helvetica, Arial, sans-serif',
				fontSize: '13px',
				width: '80%',
				margin: '0 auto'
			},
			moreBlurb: {
				fontFamily: 'Helvetica, Arial, sans-serif',
				fontSize: '13px',
				marginTop: '18px'
			}
		};

		return _react2.default.createElement(
			'div',
			{ ref: 'container', style: _extends({}, Styles.generalWrapper, Styles.PrimaryFontFamily) },
			_react2.default.createElement(_IconTopper2.default, { flowType: this.props.flowType }),
			_react2.default.createElement(
				'div',
				{ style: styles.interstitialWrapper },
				_react2.default.createElement(_ContactThumbnail2.default, { thumbnailUrl: this.props.thumbnailUrl }),
				_react2.default.createElement('h2', { style: _extends({}, Styles.ViewHeaderText, styles.paymentContent), dangerouslySetInnerHTML: { __html: this.props.paymentContentHTML } }),
				!!this.props.note && _react2.default.createElement(
					'p',
					null,
					'"',
					this.props.note,
					'"'
				),
				_react2.default.createElement('div', { style: styles.line }),
				_react2.default.createElement(
					'h2',
					{ style: _extends({}, Styles.ViewHeaderText, styles.headerText) },
					this.props.mainContent.headerText
				),
				_react2.default.createElement(
					'div',
					{ style: styles.inputWrapper },
					_react2.default.createElement('div', { className: 'icon icon-medium icon-send-money', style: _extends({}, styles.icon) }),
					_react2.default.createElement(
						'div',
						{ style: styles.inputDetailsWrapper },
						_react2.default.createElement(
							'div',
							{ onClick: function onClick() {
									return _this.handleTypeChange('F&F');
								}, style: styles.clickableText },
							_react2.default.createElement(
								'h3',
								{ style: styles.inputTitle },
								this.props.mainContent.friendsAndFamily.title
							),
							_react2.default.createElement('span', { className: 'icon icon-small icon-arrow-right-small', style: styles.arrowIcon })
						),
						_react2.default.createElement(
							'p',
							{ style: styles.typeBlurb },
							this.props.mainContent.friendsAndFamily.blurb
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ style: styles.inputWrapper },
					_react2.default.createElement('div', { className: 'icon icon-medium icon-register', style: _extends({}, styles.icon, styles.registerPadding) }),
					_react2.default.createElement(
						'div',
						{ style: styles.inputDetailsWrapper },
						_react2.default.createElement(
							'div',
							{ onClick: function onClick() {
									return _this.handleTypeChange('G&S');
								}, style: styles.clickableText },
							_react2.default.createElement(
								'h3',
								{ style: styles.inputTitle },
								this.props.mainContent.goodsAndServices.title
							),
							_react2.default.createElement('span', { className: 'icon icon-small icon-arrow-right-small', style: styles.arrowIcon })
						),
						_react2.default.createElement(
							'div',
							{ style: styles.recommendedWrapper },
							_react2.default.createElement('span', { style: styles.checkmark, className: 'icon icon-small icon-positive-small', 'aria-hidden': true }),
							_react2.default.createElement(
								'p',
								{ style: styles.recommendedBlurb },
								this.props.mainContent.goodsAndServices.recommended
							)
						),
						_react2.default.createElement(
							'p',
							{ style: styles.typeBlurb },
							this.props.mainContent.goodsAndServices.blurb
						)
					)
				),
				_react2.default.createElement('div', { style: styles.line }),
				this.props.mainContent.footerNote && _react2.default.createElement(
					'p',
					{ style: styles.saveBlurb },
					this.props.mainContent.footerNote
				),
				_react2.default.createElement('p', { style: styles.moreBlurb, dangerouslySetInnerHTML: { __html: this.props.mainContent.PPPNote } })
			)
		);
	}
});

exports.default = PaymentInterstitial;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /workspace/Release/~/guest-payment/dist/components/PaymentInterstitial.js
// module id = 345
// module chunks = 6